import "../PageCommon.css";
import "./MnRSchedule.css";

const MnRSchedulePage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>M&R schedule</h2>
        </div>
      </div>
    </div>
  );
}

export default MnRSchedulePage;